
export const SECRET_TO_PLATFORM_MAP: Record<string, string> = {
  'OPENAI_API_KEY': 'openai',
  'ANTHROPIC_API_KEY': 'anthropic',
  'GEMINI_API_KEY': 'gemini',
  'ELEVENLABS_API_KEY': 'elevenlabs',
  'SCRAPELESS_API_KEY': 'scrapeless',
  'MICROSOFT_CLIENT_ID': 'microsoft365',
  'GMAIL_CLIENT_ID': 'google-calendar',
  'RESEND_API_KEY': 'resend'
};

export const PLATFORM_CATEGORIES: Record<string, string> = {
  // AI Services
  'openai': 'ai',
  'anthropic': 'ai', 
  'gemini': 'ai',
  'elevenlabs': 'ai',
  
  // Recruiting
  'linkedin': 'recruiting',
  'indeed': 'recruiting',
  
  // Communication
  'outlook-email': 'communication',
  
  // Calendar
  'microsoft365': 'calendar',
  'google-calendar': 'calendar',
  
  // Tools
  'resend': 'tools',
  'scrapeless': 'tools'
};
